import { render, staticRenderFns } from "./payment-component-on-page.vue?vue&type=template&id=a6494cc0&"
import script from "./payment-component-on-page.vue?vue&type=script&lang=js&"
export * from "./payment-component-on-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports